import { useState } from "react"
import { FloatingAgentButton } from "./floating-agent-button"
import { AgentChatPanel } from "./agent-chat-panel"

export function AgentWidget() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <FloatingAgentButton onClick={() => setIsOpen(true)} isOpen={isOpen} />
      <AgentChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
